module.exports = __webpack_public_path__ + "static/img/琴.6037fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/琴.png
// module id = Pmq1
// module chunks = 4